import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import ModalComponent from "../../components/modalComponent";
import SelectInput from "../../components/selectInput";
import ButtonComponent from "../../components/button";
import { user_license_status_select } from "../../utils/selectsValues";

const ReadOnlyField = ({ label, value }) => (
  <div style={{ marginBottom: 16 }}>
    <p style={{ margin: 0, fontSize: 12, color: "#666" }}>{label}</p>
    <p style={{ margin: "4px 0 0", fontWeight: 500 }}>{value || "—"}</p>
  </div>
);

const EditUserLicenseModal = ({ open, onClose, userRow, onSubmit }) => {
  const { control, handleSubmit, reset } = useForm({
    defaultValues: { licenseStatus: 1 }
  });

  useEffect(() => {
    if (open && userRow) {
      reset({ licenseStatus: userRow.licenseStatus ?? 1 });
    }
  }, [open, userRow, reset]);

  const handleFormSubmit = (formData) => {
    onSubmit(userRow, formData.licenseStatus);
  };

  const fullName = userRow
    ? `${userRow.lastName ?? ""} ${userRow.name ?? ""}`.trim()
    : "";

  return (
    <ModalComponent
      open={open}
      onClose={onClose}
      title="Licencia del usuario"
      customWidth="480px"
      onSubmit={handleSubmit(handleFormSubmit)}
    >
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <ReadOnlyField label="Nombre" value={fullName} />
        <ReadOnlyField label="Email" value={userRow?.email} />
        <ReadOnlyField label="Cargo" value={userRow?.position} />
        <SelectInput
          name="licenseStatus"
          control={control}
          label="Estado de licencia"
          options={user_license_status_select}
        />
        <div className="HContainer j-center mt-20">
          <ButtonComponent
            type="button"
            onClick={onClose}
            backgroundColor="#fff"
            textColor="#666"
            width="120px"
            margin="0 10px 0 0"
          >
            Cancelar
          </ButtonComponent>
          <ButtonComponent
            type="submit"
            backgroundColor="#F6C079"
            textColor="#000000"
            width="140px"
          >
            Guardar
          </ButtonComponent>
        </div>
      </form>
    </ModalComponent>
  );
};

export default EditUserLicenseModal;
